import { createContext, useContext, useEffect, useState } from "react";
import { api, useAuth } from "@/context/AuthContext";

const CompanyContext = createContext(null);
export const DEFAULT_COMPANY = "Flexistay Luton Limited";

export function CompanyProvider({ children }) {
  const { token } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [company, setCompanyState] = useState(
    localStorage.getItem("company") || DEFAULT_COMPANY
  );

  const setCompany = (c) => {
    localStorage.setItem("company", c);
    setCompanyState(c);
  };

  const refresh = async () => {
    try {
      const r = await api.get("/companies");
      setCompanies(r.data);
    } catch {}
  };

  // Refetch whenever the auth token changes (login/logout/first mount with token)
  useEffect(() => {
    if (token) refresh();
    else setCompanies([]);
  }, [token]);

  // Attach company as default query param via axios interceptor
  useEffect(() => {
    const id = api.interceptors.request.use((cfg) => {
      cfg.params = { ...(cfg.params || {}) };
      if (!("company" in cfg.params) && company) cfg.params.company = company;
      return cfg;
    });
    return () => api.interceptors.request.eject(id);
  }, [company]);

  return (
    <CompanyContext.Provider value={{ companies, company, setCompany, refresh }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
